export class DateUtils {
  static localDateToApiString(date: string | Date | null): string | null {
    if (!date) return null;

    let d: Date;
    if (typeof date === 'string') {
      const parsed = new Date(date);
      if (isNaN(parsed.getTime())) return null;
      d = parsed;
    } else {
      d = date;
    }
    const isoDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 0, 0);
    return isoDate.toISOString();
  }
}
